import React from 'react';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import DownloadIcon from '@mui/icons-material/Download';
import ArticleIcon from '@mui/icons-material/Article';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import axios from 'axios';
import { authUtils } from 'utils/authUtils.js';

const PgmItemComponent = (props) => {
  const { id, engNm, ver, downloadCnt, totalCnt, thumbnailImgName, fileName, manualName, mediaUrl, versionId, handleOpen, setMediaName, setMediaUrl, handleVersionOpen, setPgmNm, setVersionId, setVersionState, handleVersionRegisterOpen, readOnly = false } =
    props;
  let params = { id };

  const handleFileDownClick = async (e) => {
    await fileDown(fileName);
    await axios.patch(`/api/incrementDownloadCount/${id}`);
  };

  const handleManualDownClick = async (e) => {
    await fileDown(manualName);
  };

  const handleMediaOpenClick = async (e) => {
    handleOpen();
    setMediaName(engNm);
    setMediaUrl(mediaUrl);
  };

  const handleVersionOpenClick = async (e) => {
    await setPgmNm(engNm);
    if (!!versionId) {
      await setVersionId(versionId);
      await handleVersionOpen();
    } else if (!readOnly) {
      await setVersionState('register');
      await handleVersionRegisterOpen();
    }
  };

  const fileDown = async (fileName) => {
    let params = {
      file: `${fileName}`
    };
    await axios
      .get(`/api/file/${fileName}`, { params, responseType: 'blob' })
      .then((response) => {
        let blob = new Blob([response.data], {
          type: <response className="headers"></response>
        });
        let name = getFileName(decodeURIComponent(response.headers['content-disposition']));
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, name);
        } else {
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.target = '_self';
          if (name) link.download = name;
          link.click();
          window.URL.revokeObjectURL(link);
        }
      })
      .catch((error) => {
        alert('다운로드 실패!');
      });
  };

  const getFileName = (contentDisposition) => {
    let fileName = contentDisposition
      .split(';')
      .filter((el) => el.indexOf('filename') > -1)
      .map((ele) => ele.replace(/"/g, '').split('=')[1]);
    return fileName[0];
  };

  return (
    <Card
      variant="outlined"
      sx={{
        width: 303
      }}
    >
      <CardHeader
        title={engNm}
        action={
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            ver {ver}
          </Typography>
        }
      />
      <Tooltip title="버전 내역" onClick={(readOnly ? !!versionId : authUtils.useIsAdmin() || !!versionId) ? handleVersionOpenClick : undefined}>
        <CardMedia component="img" height="202" image={'/api/img/' + thumbnailImgName} alt={engNm} style={{ border: '1px solid', cursor: (readOnly ? !!versionId : authUtils.useIsAdmin() || !!versionId) ? 'pointer' : '' }} />
      </Tooltip>
      <CardContent sx={{ pb: 0, pt: 2 }}>
        <Typography variant="body2" color="text.secondary">
          누적 실행 : {Math.round(totalCnt).toLocaleString()}
        </Typography>
      </CardContent>
      <CardActions sx={{ pb: 0, pt: 0 }}>
        <Tooltip title={`제품 다운로드`}>
          <IconButton aria-label="down" onClick={handleFileDownClick}>
            <DownloadIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="다운로드 수">
          <Typography variant="body1">{downloadCnt}</Typography>
        </Tooltip>
        {!!manualName && (
          <Tooltip title="메뉴얼 다운로드">
            <IconButton aria-label="manualDown" onClick={handleManualDownClick}>
              <ArticleIcon />
            </IconButton>
          </Tooltip>
        )}
        {!!mediaUrl && (
          <Tooltip title="소개영상 시청하기">
            <IconButton aria-label="mediaDown" onClick={() => handleMediaOpenClick()}>
              <PlayCircleIcon />
            </IconButton>
          </Tooltip>
        )}
      </CardActions>
    </Card>
  );
};

export default PgmItemComponent;
